// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"az_Djb","question":"az_Ejb","answer":"az_Fjb","accordionItem":"az_Gjb"};